import type { DefaultMantineColor } from '@mantine/core'

interface StatusColors {
  [status: string]: DefaultMantineColor
}

export const statusToColor: StatusColors = {
  draft: 'gray',
  active: 'blue',
  'on-hold': 'yellow',
  revoked: 'red',
  completed: 'green',
  'entered-in-error': 'red',
  unknown: 'gray',
}
